import { Box, Typography } from "@mui/material";
import { UPLOAD_LEADS_MODAL_TITLE } from "@/modules/upload-leads/consts/index";
import UploadLeads from "./upload-leads";
import ResponsiveEditDialog from "@/modules/common/components/modals/responsive-edit-dialog";

interface UploadLeadsModalProps {
  toggleUploadLeadsModal: boolean;
  setToggleUploadLeadsModal: (toggleUploadLeadsModal: boolean) => void;
}

const UploadLeadsModal = ({
  toggleUploadLeadsModal,
  setToggleUploadLeadsModal,
}: UploadLeadsModalProps) => {
  return (
    <ResponsiveEditDialog
      open={toggleUploadLeadsModal}
      setOpen={setToggleUploadLeadsModal}
      hideModalFooter
      modalFooter={false}
      header={
        <Typography variant="h3_med">{UPLOAD_LEADS_MODAL_TITLE}</Typography>
      }
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          minHeight: "100%",
          gap: 2,
          padding: { mobile: "8px 0px", tablet: "16px 24px 32px 16px" },
          margin: { mobile: "8px 0px", tablet: 0, desktop: 0 },
        }}
      >
        <UploadLeads setToggleUploadLeadsModal={setToggleUploadLeadsModal} />
      </Box>
    </ResponsiveEditDialog>
  );
};

export default UploadLeadsModal;
